import { render, staticRenderFns } from "./CargoOther.vue?vue&type=template&id=6f82b160&"
import script from "./CargoOther.vue?vue&type=script&lang=js&"
export * from "./CargoOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports